/**
 * ログインの認証番号の SMS が、アプリ名のせいで1通に収まらなくなっていないか（issue #524）。
 *
 * SMS の本文は「【アプリ名】認証番号は 123456 です。10分以内に画面へご入力ください。この番号は他の方に
 * 教えないでください。」です（サーバの server/src/auth/invite-service.ts の buildSmsBody）。
 * 日本語の入る SMS は1通70文字までで、超えると2通分以上の料金になります。
 * サーバと同じ数え方であることは、両方の試験が shared/sms-body-cases.json を読んで確かめます。
 */

/** SMS 1通に収まる文字数（日本語が入る本文）。 */
export const SMS_SINGLE_MESSAGE_MAX_CHARS = 70;

/** このアプリ名で送る SMS の本文の文字数（認証番号は6桁・有効期間は既定の10分で数える）。 */
export function smsBodyLength(appName: string, ttlMinutes = 10): number {
  // 文字数は SMS の数え方にそろえる（絵文字など一部の文字は2文字に数える＝JavaScript の length と同じ）
  return `【${appName.trim()}】認証番号は 000000 です。${ttlMinutes}分以内に画面へご入力ください。この番号は他の方に教えないでください。`
    .length;
}

/** このアプリ名だと、認証番号の SMS が1通に収まらない（2通分以上の料金になる）か。 */
export function smsBodyExceedsSingle(appName: string, ttlMinutes = 10): boolean {
  return smsBodyLength(appName, ttlMinutes) > SMS_SINGLE_MESSAGE_MAX_CHARS;
}
